<template>
  <div class="score_wrap" @scroll="handleScroll" >
    <div class="top" >
      <div class="headers_wrap" >
        <div>可用积分</div>
        <div>{{ userVo.userIntegral }}</div>
        <div class="use_btn" @click="luckDraw" >去使用</div>
      </div>

      <div class="score_title" >
        <img src="./img/tips.png" />
        <div>积分明细</div>
        <img src="./img/tips.png" />
      </div>
    </div>

    <div class="score_list" >
      <div class="score_item" v-for="(item, index) in userIntegralHistoryVoList" :key="index" >
        <div>
          <img src="./img/buy.png" v-if="item.integral.indexOf('-') === -1" />
          <img src="./img/luckdraw.png" v-else  />
          <div>
            <div>{{ item.typeStr }}</div>
            <div>{{ item.createTime }}</div>
          </div>
        </div>
        <div class="buy_money" v-if="item.integral.indexOf('-') === -1" >+{{ item.integral }}</div>
        <div class="luckdraw_money" v-else >{{ item.integral }}</div>
      </div>
    </div>

    <van-empty description="暂无积分明细" v-if="userIntegralHistoryVoList.length <= 0" style="margin-top: 30px;" />
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import { getUserIntegralHistoryVoListByPage, getEnableLuckDrawVo } from '@/api/luckdraw'
import fail from '../home/img/fail.png'
import {Toast} from 'vant';
export default {
  name: 'scoreList',
  data() {
    return {
      userVo: JSON.parse(localStorage.getItem('userVo')),
      page: 1,
      pageSize: 20,
      userIntegralHistoryVoList: []
    }
  },
  methods: {
    luckDraw() {
      getEnableLuckDrawVo({}).then(res => {
        console.log('res:', res)
        if(res.success) {
          let luckDrawVo = res.data.luckDrawVo
          let luckDrawGoodsVoList = res.data.luckDrawGoodsVoList
          luckDrawGoodsVoList.map(item => {
            if(!item.luckDrawGoodsId) {
              item.picUrl = fail
            }
          })
          localStorage.setItem('luckDrawVo', JSON.stringify(luckDrawVo))
          localStorage.setItem('luckDrawGoodsVoList', JSON.stringify(luckDrawGoodsVoList))
          this.$router.push({ name: 'luckDraw', params: { luckDrawId: luckDrawVo.luckDrawId } })
        }else {
          Toast(res.msg)
        }
      })
    },
    handleScroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      if (scrollTop + clientHeight >= scrollHeight - 50){
        this.page++
        this.getUserIntegralHistoryVoListByPage()
      }
    },
    getUserIntegralHistoryVoListByPage() {
      const { page, pageSize } = this
      getUserIntegralHistoryVoListByPage({ page, pageSize }).then(res => {
        console.log(res)
        if(res.success) {
          this.userIntegralHistoryVoList = this.userIntegralHistoryVoList.concat(res.data)
        }
      })
    }
  },
  mounted() {
    this.getUserIntegralHistoryVoListByPage()
  }
}
</script>
